import { resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import { computed, defineComponent, useCssModule, provide, ref, onMounted, onUnmounted, nextTick } from "vue";
import { Btn, Icon } from "linkd-ui";
import YQueryItem1 from "./YQueryItem.vue";
const YQueryItem = YQueryItem1;
export default defineComponent({
  props: {
    searchText: {
      type: String,
      default: "查询"
    },
    hasSearchButton: {
      type: Boolean,
      default: true
    },
    flexEnd: {
      type: Boolean,
      default: false
    },
    spaceBetween: {
      type: Boolean,
      default: true
    },
    equal: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "medium"
    },
    gutter: {
      type: String,
      default: ""
    },
    //是否显示展开收起的提示
    isSpread: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Btn,
    Icon,
    YQueryItem
  },
  setup(props, ctx) {
    const css = useCssModule("css");
    const visible = ref(false);
    let isSpread = ref(props.isSpread);
    //类名设置
    const queryClass = computed(() => {
      return {
        [css.query]: true,
        [css.expanded]: !visible.value,
        [css.flex_end]: props.flexEnd,
        [css.space_between]: props.spaceBetween
      };
    });
    //内容显示
    const content = computed(() => {
      //筛选的展开与收起
      let moreFilter = _createVNode("div", {
        "class": css.cursor,
        "onClick": () => visible.value = !visible.value
      }, [_createTextVNode("\u66F4\u591A\u7B5B\u9009"), _createVNode(Icon, {
        "name": "w-icon-arrow-down",
        "rotate": visible.value,
        "color": "#aaa"
      }, null)]);
      //query里的内容
      let querycontent = [props.hasSearchButton ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createVNode(Btn, {
          "type": "primary",
          "onClick": el => {
            ctx.emit("search");
          }
        }, {
          default: () => [props.searchText]
        })]
      }) : null, ctx.slots.append?.(), isSpread.value ? _createVNode(_resolveComponent("y-query-item"), null, {
        default: () => [_createTextVNode(" "), moreFilter, _createTextVNode(" ")]
      }) : null];
      if (props.spaceBetween) {
        querycontent = [_createVNode("div", {
          "class": css.q
        }, [ctx.slots.default?.()]), _createVNode("div", {
          "class": [css.q, css.bottom]
        }, [querycontent])];
      }
      return querycontent;
    });
    const tableBox = ref();
    const getWidth = () => {
      nextTick(() => {
        if (tableBox.value && !props.isSpread) {
          //div容器获取tableBox.value.clientWidth
          let newWidth = tableBox.value.clientWidth;
          // width.value = (newWidth - 450) / 2;
          if (newWidth <= 1400) {
            isSpread.value = true;
          } else {
            isSpread.value = false;
          }
        }
      });
    };
    onMounted(() => {
      getWidth();
      window.addEventListener("resize", getWidth);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", getWidth);
    });
    //子组件的通信
    provide("size", props.size);
    provide("equal", props.equal);
    return () => _createVNode("div", {
      "style": {
        marginBottom: props.gutter
      },
      "class": queryClass.value,
      "ref": tableBox
    }, [content.value]);
  }
});